module.exports = __webpack_public_path__ + "static/media/206-Telefonat_ID_21.b7feb2a6.mp3";